// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import './AllergiesHoverOverPopUpItem.scss'
import { isActiveEllipsisCheck, severitiesData } from '../../../utils/common'

const UNKNOWN_SEVERITY = 'Unknown severity'

/**
 * `?? Severity` would be wrong here: an unrecognised or missing severity renders as
 * `Penicillin ()`, which reads as a formatting glitch rather than as missing clinical
 * data. Name the gap instead.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getSeverityLabel = (Severity) => severitiesData[Severity]?.value ?? UNKNOWN_SEVERITY

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const AllergiesHoverOverPopUpItem = ({ Name, Severity, ItemId, isLastItem, author }) => {
  const [isNameToolTipActive, setIsNameToolTipActive] = useState(false)
  const [isSeverityToolTipActive, setIsSeverityToolTipActive] = useState(false)
  const [isNameToolTipHovered, setIsNameToolTipHovered] = useState(false)
  const [isSeverityToolTipHovered, setIsSeverityToolTipHovered] = useState(false)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOverHandler = (type) => () => {
    switch (type) {
      case 'allergy': {
        setIsNameToolTipHovered(true)
        break
      }
      case 'author': {
        setIsSeverityToolTipHovered(true)
        break
      }
      default:
        break
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOutHandler = (type) => () => {
    switch (type) {
      case 'allergy': {
        setIsNameToolTipHovered(false)
        break
      }
      case 'author': {
        setIsSeverityToolTipHovered(false)
        break
      }
      default:
        break
    }
  }

  useEffect(() => {
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    isActiveEllipsisCheck(`allergy-${ItemId}`, setIsNameToolTipActive)
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    isActiveEllipsisCheck(`author-${ItemId}`, setIsSeverityToolTipActive)
  }, [])

  return (
    <div className='allergies-hover-over-pop-up-item'>
      <label
        onMouseLeave={onMouseOutHandler('allergy')}
        onMouseEnter={onMouseOverHandler('allergy')}
        id={`allergy-${ItemId}`}
        className='allergies-hover-over-pop-up-item-title'>
        <div />
        {Name} ({getSeverityLabel(Severity)})
      </label>
      {isNameToolTipActive && isNameToolTipHovered ?
        <div style={{ top: isLastItem ? 0 : 30 }} className='allergies-hover-over-pop-up-name-tooltip'>
          {Name} ({getSeverityLabel(Severity)})
        </div>
      : null}
      <div
        onMouseLeave={onMouseOutHandler('author')}
        onMouseEnter={onMouseOverHandler('author')}
        id={`author-${ItemId}`}
        className='allergies-hover-over-pop-up-item-body'>
        <div />
        {author}
      </div>
      {isSeverityToolTipActive && isSeverityToolTipHovered ?
        <div style={{ top: isLastItem ? -12 : 65 }} className='allergies-hover-over-pop-up-name-tooltip'>
          {author}
        </div>
      : null}
    </div>
  )
}
